// Module
var code = "<template>\n  <div class=\"\">\n    generell oversikt...\n  </div>\n</template>\n";
// Exports
export default code;